import React, { useState, useRef, useEffect } from 'react';
import MappedInMapSimple from './MappedInMapSimple';

const AvatarScreenTest = () => {
  const [isMapReady, setIsMapReady] = useState(false);
  const [videoDuration, setVideoDuration] = useState(0);
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleLoadedMetadata = () => {
      console.log('[TEST] Video duration:', video.duration);
      setVideoDuration(video.duration);
    };

    video.addEventListener('loadedmetadata', handleLoadedMetadata);
    return () => video.removeEventListener('loadedmetadata', handleLoadedMetadata);
  }, []);

  const handleMapReady = () => {
    console.log('[TEST] Map is ready!');
    setIsMapReady(true);
  };

  const handlePlayVideo = () => {
    if (videoRef.current && isMapReady) {
      videoRef.current.play();
    }
  };

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        backgroundColor: '#000',
      }}
    >
      {/* Left Side - Video */}
      <div
        style={{
          width: '50%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          backgroundColor: '#1a1a1a',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '800px',
            backgroundColor: '#000',
            borderRadius: '15px',
            overflow: 'hidden',
            boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
          }}
        >
          <video
            id="avatarVideo"
            ref={videoRef}
            style={{ width: '100%', height: 'auto', display: 'block' }}
            controls
            crossOrigin="anonymous"
          >
            <source src="/MappedIn-dummy.mp4" type="video/mp4" />
            <track kind="captions" src="/captions.vtt" srcLang="en" label="English" default />
          </video>
        </div>

        {/* Video Info */}
        <div
          style={{
            marginTop: '20px',
            color: '#fff',
            textAlign: 'center',
          }}
        >
          <p style={{ fontSize: '14px', marginBottom: '10px' }}>
            Duration: {videoDuration.toFixed(2)}s
          </p>
          <p
            style={{
              fontSize: '12px',
              color: isMapReady ? '#4CAF50' : '#FF9800',
              fontWeight: 'bold',
            }}
          >
            {isMapReady ? '✓ Map Ready - You can play the video' : '⏳ Loading map...'}
          </p>
          {isMapReady && (
            <button
              onClick={handlePlayVideo}
              style={{
                marginTop: '15px',
                padding: '12px 30px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold',
                boxShadow: '0 2px 10px rgba(76, 175, 80, 0.3)',
              }}
            >
              ▶ Play Video & Navigation
            </button>
          )}
        </div>
      </div>

      {/* Right Side - Map */}
      <div
        style={{
          width: '50%',
          height: '100%',
          padding: '20px',
          backgroundColor: '#2a2a2a',
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            borderRadius: '15px',
            overflow: 'hidden',
            boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
          }}
        >
          <MappedInMapSimple
            spaceName="Gothem News"
            brandColor="#127E10"
            onMapReady={handleMapReady}
            videoDuration={videoDuration}
          />
        </div>
      </div>

      {/* Instructions Overlay */}
      {!isMapReady && (
        <div
          style={{
            position: 'fixed',
            top: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'rgba(0,0,0,0.9)',
            color: '#fff',
            padding: '15px 30px',
            borderRadius: '10px',
            zIndex: 9999,
            textAlign: 'center',
            boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
          }}
        >
          <p style={{ margin: 0, fontSize: '14px' }}>
            🗺️ Preparing navigation route... Please wait
          </p>
        </div>
      )}
    </div>
  );
};

export default AvatarScreenTest;
